export default __webpack_public_path__ + "static/media/yellow_tap_cut.d97780f3.png";